'use strict';

var React = require('react');

var SvgInventoryUpdatedIcon = function SvgInventoryUpdatedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.265 2.952a2.25 2.25 0 0 0-2.53 0l-4.094 2.783a3.75 3.75 0 0 0-1.641 3.101v7.413a.75.75 0 0 0 1.5 0v-7.413c0-.745.369-1.441.985-1.86l4.093-2.784a.75.75 0 0 1 .844 0l4.093 2.784a2.25 2.25 0 0 1 .985 1.86v7.413a.75.75 0 0 0 1.5 0v-7.413a3.75 3.75 0 0 0-1.641-3.1l-4.094-2.784Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.28 10.28a.75.75 0 0 0-1.06-1.061l-2.97 2.97-1.22-1.22a.75.75 0 1 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0l3.5-3.5Z"
  }));
};
SvgInventoryUpdatedIcon.displayName = "InventoryUpdatedIcon";

exports.SvgInventoryUpdatedIcon = SvgInventoryUpdatedIcon;
